<template>
  <div class="oneitem">

    <div id="main" class="wh1200">
      <div class="crumbs">
        <div class="name">您现在所在位置：</div>
        <div class="crumbs_box">
          <a href="/">首页</a>
          <a href="/topic">专题新闻</a>
          <a @click="back">专题内容列表</a>
          <a href="javascript:;">详情</a>
        </div>
      </div>
      <div class="details_content">
        <div class="details_top">
          <div class="details_title">{{cont.title}}</div>
          <div class="details_xinxi">
            <div class="xinxi_box">
              <div><img src="../../static/time_icon.png" alt="">发布日期：{{cont.time}}</div>
              <div><img src="../../static/laiyuan_icon.png" alt="">来源：{{cont.start}}</div>
              <div><img src="../../static/zuozhe_icon.png" alt="">作者：{{cont.author}}</div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="details_bottom" v-html="cont.content"></div>
        <a class="fanhui_link" @click="back">返回专题</a>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import pages from '@/components/pages'
import news from '@/api/modules/news'
export default {
  data () {
    return {
      count: 1,
	  ztid: 0,
      from: {
        'special_item_id': this.$route.query.id
      },
      cont: []
    }
  },
  components: {
    pages
  },
  created () {
    this.content()
  },
  methods: {
    changPage (index) {
      this.sendFrom.page = index
      this.init()
    },

    back(){
      // console.log(this.cont);
      this.$router.push({
        path: '/topicont',
        query: {
          'id': this.cont.special_id
        }
      })
    },

    pages (id) {
      this.$router.push({
        path: '/oneitem',
        query: {
          'id': id
        }
      })
    },
    content () {
      axios({
        method: 'post',
        url: news.oneitem,
        data: this.from
      }).then(res => {
        this.count = Number.parseInt(Math.ceil(res.data.count / 10))
        this.cont = res.data
      })
    },
    richtext (text) {
      let str = text
      str = str.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
      str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
      str = str.replace(/\n[\s| | ]*\r/g, '\n') // 去除多余空行
      return str
    }
  }
}
</script>

<style scoped>
  @import '../../style/public';
  @import '../../style/comm';

</style>



// WEBPACK FOOTER //
// src/pages/news/oneitem.vue